import { API_EC } from '@/config/api.config';
import { axiosEc } from '@/config/axios.config';

/**
 * 取得作品分享狀態
 */
export const getPortfolioShareStatus = <TResponse>(bookId: string) => {
    return axiosEc.get<TResponse>(API_EC.CHECK_SHARE_BOOK_STATUS, {
        params: { BookId: bookId },
    });
};

/**
 * 送出作品分享設定 (分享/重新分享/取消分享)
 */
export const submitPortfolioShare = (input: {
    bookId: string;
    shareToGainHow: boolean;
    isResharing: boolean;
    cancelSharing: boolean;
}) => {
    return axiosEc.get(API_EC.DO_SHARE, {
        params: {
            bookID: input.bookId,
            shareToGainHow: input.shareToGainHow,
            isResharing: input.isResharing,
            cancelSharing: input.cancelSharing,
        },
    });
};
